function clickMapper(data) {
    return {
        event: 'productClick',
        ecommerce: {
            click: {
                actionField: { list: data.list },
                products: [
                    {
                        name: data.card.Name,
                        id: `dis_${data.card.ID}`,
                        position: data.position
                    }
                ]
            }
        }
    };
}

function detailMapper(data) {
    return {
        event: 'productDetail',
        ecommerce: {
            detail: {
                actionField: { list: data.list },
                products: [
                    {
                        name: data.card.Name,
                        id: `dis_${data.card.ID}`
                    }
                ]
            }
        }
    };
}

module.exports = {
    clickMapper,
    detailMapper
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/atmmapper/inspiration-atm-mapper.js
 **/